import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAramexRate } from "../../../store/actions/shipping";
import AramexLogo from "../assets/aramex-logo.svg";
import { ReactComponent as GenericShippingLogo } from "../assets/delivery-truck.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

const AramexShipping = () => {
  const dispatch = useDispatch();
  const {
    language,
    settings,
    shipping,
    applied_promo,
    discounts,
    aramex_error,
  } = useSelector((state) => ({
    language: state.store.language,
    settings: state.store.store.settings,
    shipping: state.shipping,
    applied_promo: state.cart.promos,
    discounts: state.cart.discounts,
    aramex_error: state.shipping.aramex_error,
  }));

  useEffect(() => {
    if (settings.enable_aramex) {
      dispatch(getAramexRate());
    }
  }, []);

  const currency =
    language === "english"
      ? settings.currency_english
      : settings.currency_local;

  const hasFreeDelivery =
    applied_promo?.discount_type === "delivery" || discounts?.delivery?.length;
  const currencyIcon = getCurrencyIcon(settings)
  if (aramex_error) {
    return <></>;
  }
  return (
    <div style={{ marginTop: 30 }}>
      <p
        className="box-title"
        style={{ textAlign: language === "arabic" ? "right" : "left" }}
      >
        {language === "english" ? "Shipping Method" : "الشحن"}
      </p>
      <div
        className="border-top border-bottom w-100 mx-0 p-3"
        style={{ backgroundColor: "white", height: 80 }}
        dir={language === "english" ? "ltr" : "rtl"}
      >
        <div
          className={"ml-0 ".concat(
            language === "english" ? "text-left" : "text-right"
          )}
          style={{
            fontSize: "1rem",
            fontWeight: 400,
            alignItems: "center",
            display: "grid",
            gridTemplateColumns: "80px auto",
            height: "100%",
            alignContent: "center",
          }}
          dir={language === "english" ? "ltr" : "rtl"}
        >
          <div className="p-2 py-3">
            {!settings.has_custom_shipping_rates ? (
              <img src={AramexLogo} style={{ width: 62, height: 35 }} />
            ) : (
              <GenericShippingLogo
                style={{
                  width: 62,
                  height: 35,
                  transform: language === "arabic" ? "rotateY(180deg)" : "",
                }}
              />
            )}
          </div>
          <div className="p-2 py-3">
            {shipping.loading ? (
              <span>
                <CircularProgress
                  color="primary"
                  style={{
                    width: 20,
                    height: 20,
                    marginRight: language === "arabic" ? 30 : 0,
                    marginLeft: language === "english" ? 30 : 0,
                  }}
                />{" "}
              </span>
            ) : (
              <div>
                {!settings.has_custom_shipping_rates ? (
                  <p className="mb-1">
                    {language === "arabic" ? "الشحن بواسطة" : "Shipping using"}{" "}
                    <span style={{ fontWeight: "bold" }}>Aramex</span>
                  </p>
                ) : (
                  <p className="mb-1">
                    {language === "arabic"
                      ? "شحن دولي"
                      : "International Shipping"}
                  </p>
                )}
                {shipping?.data?.total_value && (
                  <p>
                    <span style={{ fontWeight: "bold" }}>
                      {language === "arabic" ? "التكلفة" : "Cost"}:
                    </span>{" "}
                    <span
                      className={
                        currencyIcon
                      }
                      style={{
                        textDecoration: hasFreeDelivery
                          ? "line-through"
                          : "none",
                      }}
                    >
                      {parseFloat(shipping.data?.total_value).toFixed(3)}{" "}
                      {currency}
                    </span>{" "}
                    {hasFreeDelivery !== 0 && (
                      <span className="bold">Free</span>
                    )}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AramexShipping;
